/**
 * The per-chunk VAD-vs-claim-floor comparison exists to answer one open
 * question with production data -- does the deliberately ungated rolling
 * scorer credit room tone to somebody -- not to measure every chunk forever
 * (#438). It runs on the first harvest of a page load and every Nth after
 * that: a 20% sample at no embedding cost, dense enough to catch silence
 * being credited, light enough that a 4-hour meeting stops paying main-thread
 * DSP for a question that long since answered itself on this device.
 */
export const VAD_DIAGNOSTIC_SAMPLE_EVERY = 5;

/**
 * One sampler's cadence: first call due, every Nth after. A factory rather
 * than module state so a test drives its own without touching the engine's.
 */
export function createVadDiagnosticSampler(): () => boolean {
  let seen = 0;
  return () => {
    seen += 1;
    return seen === 1 || (seen - 1) % VAD_DIAGNOSTIC_SAMPLE_EVERY === 0;
  };
}

/**
 * The engine's sampler. One per page load is the right granularity: the
 * question being answered is a property of the device's mic chain and room,
 * which a session boundary does not reset.
 */
export const vadDiagnosticDue = createVadDiagnosticSampler();
